import notificationMessages from './notificationMessages'

/**
 * Parse and translate notification message (title or description) from backend
 * @param {string} data - Raw notification text or JSON with message key
 * @param {function} formatMessage - react-intl formatMessage function
 * @returns {string} Translated message or fallback text
 */
export const parseNotificationMessage = (data, formatMessage) => {
  if (!data) return data

  // Check if data contains multiple JSON objects (newline-delimited)
  if (typeof data === 'string' && data.includes('\n')) {
    const lines = data.split('\n').filter((line) => line.trim())
    if (lines.length > 1) {
      // Parse each line separately and join with newline
      const parsed = lines
        .map((line) => parseNotificationMessage(line.trim(), formatMessage))
        .filter(Boolean)
        .join('\n')
      return parsed
    }
  }

  try {
    // Try to parse as JSON (new format with message key)
    const parsed = JSON.parse(data)
    const messageKey = toCamelCase(parsed.MessageKey)

    if (parsed.MessageKey && notificationMessages[messageKey]) {
      const params = parsed.Params || {}
      // Convert C# PascalCase params to camelCase for JS
      const jsParams = Object.keys(params).reduce((acc, key) => {
        acc[key.charAt(0).toLowerCase() + key.slice(1)] = params[key]
        return acc
      }, {})

      const result = formatMessage(notificationMessages[messageKey], jsParams)
      return result
    }

    // Fallback to provided text if translation not found
    if (parsed.FallbackText) {
      return parsed.FallbackText
    }

    return data
  } catch (e) {
    return data
  }
}

/**
 * Convert "notification.deleteBudget" to "deleteBudget"
 */
const toCamelCase = (str) => {
  if (!str) return str
  const parts = str.split('.')
  return parts[parts.length - 1]
}
